import { Card, Table, Empty } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { DashboardWidget } from '@/api/dashboardApi';

interface TableRow {
  key: string;
  [field: string]: unknown;
}

interface TableWidgetProps {
  widget: DashboardWidget;
  data?: {
    columns: { key: string; title: string }[];
    rows: TableRow[];
  };
  loading?: boolean;
}

export default function TableWidget({ widget, data, loading }: TableWidgetProps) {
  if (!data || !data.rows || data.rows.length === 0) {
    return (
      <Card title={widget.title} size="small" loading={loading} style={{ height: '100%' }}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </Card>
    );
  }

  const columns: ColumnsType<TableRow> = (data.columns ?? []).map((col) => ({
    title: col.title,
    dataIndex: col.key,
    key: col.key,
    ellipsis: true,
  }));

  return (
    <Card title={widget.title} size="small" loading={loading} style={{ height: '100%' }}>
      <Table<TableRow>
        dataSource={data.rows}
        columns={columns}
        rowKey="key"
        size="small"
        pagination={false}
        scroll={{ y: 240 }}
      />
    </Card>
  );
}
